import React, { useState } from 'react';
import { CnStatusTag } from '@cainiaofe/cn-ui';
import cls from 'classnames';
import { clsPrefix } from '../const';
import { CnStatisticSecondaryDeckBaseProps } from './types';

const CnStatisticSecondaryDeckBaseContent = (props: CnStatisticSecondaryDeckBaseProps) => {
  const { CnFormat, CnStatisticTitle, CnStatisticMainValue, showCollapseBtn = false } = props;
  const [collapse, setCollapse] = useState(Boolean(props?.collapse) || false);

  const propsWithoutChildren = {
    ...props,
    children: undefined,
  };

  return (
    <div
      className={cls(`${clsPrefix}-secondary-deck`, {
        [`${clsPrefix}-secondary-deck-collapse`]: collapse,
      })}
    >
      <div className={cls(`${clsPrefix}-secondary-deck-title`)}>
        <div className={cls(`${clsPrefix}-secondary-deck-title-left`)}>
          {/* Status */}
          {Boolean(props.status) && (
            <CnStatusTag
              className={cls(`${clsPrefix}-secondary-deck-status`)}
              type="primary"
              status={props.status}
              size="small"
            >
              <i />
            </CnStatusTag>
          )}

          {/* Title */}
          <CnStatisticTitle
            {...propsWithoutChildren}
            title={
              <div>
                {props.title || 'hello'}

                <CnStatisticMainValue {...propsWithoutChildren} />
              </div>
            }
          />
        </div>

        {showCollapseBtn && (
          <div
            className={cls(`${clsPrefix}-secondary-deck-title-right`)}
            onClick={() => setCollapse(!collapse)}
          >
            {collapse ? '展开' : '收起'}
            <CnFormat
              type={`triangle-${collapse ? 'down' : 'up'}-fill`}
              format="CnFormatIcon"
              iconColor="#999"
            />
          </div>
        )}
      </div>

      <div className={cls(`${clsPrefix}-secondary-deck-content`)}>{props.children}</div>
    </div>
  );
};

/** 副指标组 */
const CnStatisticSecondaryDeckBase = (props: CnStatisticSecondaryDeckBaseProps) => {
  // 使用 key 来强制刷新，即满足全局刷新的需求，又不会导致组件内部的状态丢失
  return <CnStatisticSecondaryDeckBaseContent {...props} key={String(props?.collapse)} />;
};

export default CnStatisticSecondaryDeckBase;
